import { hashString } from '@uw/utils';

export interface PostMessageData extends Record<string, any> {
  action: string;
  type?: string;
}

const POST_MESSAGE_DEBOUNCE_MS = 100;
const debouncedMessageKeys = new Set<number>();

export const sendPostMessage = <T = PostMessageData>(data: T) => {
  const messageKey = hashString(JSON.stringify(data));
  // Prevents sending duplicate messages in the same UI tick.
  // For example: if sendPostMessage is called in a useEffect hook and the effect is triggered multiple time
  // it would send multiple post messages without the debounce.
  if (debouncedMessageKeys.has(messageKey)) {
    return;
  }
  debouncedMessageKeys.add(messageKey);
  setTimeout(() => {
    debouncedMessageKeys.delete(messageKey);
  }, POST_MESSAGE_DEBOUNCE_MS);

  window.parent.postMessage(
    {
      isUserWay: true,
      ...data,
    },
    '*',
  );
};
